/**
 * FORMS_DRUPAL: `on` reads Drupal for every request, `optin` only for a request carrying
 * `?forms=drupal` (staff tests), and anything else is `off`.
 */
export type FormsMode = 'off' | 'optin' | 'on'
export const formsMode = (value: unknown): FormsMode =>
  value === 'on' || value === 'optin' ? value : 'off'

/** The query param that opts a request in while FORMS_DRUPAL is `optin`. */
export const FORMS_OPTIN_PARAM = 'forms'
export const FORMS_OPTIN_VALUE = 'drupal'

/** Whether the query carries `?forms=drupal`; any other value is not an opt-in. */
export const isFormsOptIn = (query: URLSearchParams | Record<string, unknown>) =>
  (query instanceof URLSearchParams
    ? query.getAll(FORMS_OPTIN_PARAM)
    : [query[FORMS_OPTIN_PARAM]].flat()
  ).includes(FORMS_OPTIN_VALUE)

/** Whether a request reads Drupal in this mode. */
export const readsDrupal = (mode: FormsMode, optedIn: boolean) =>
  mode === 'on' || (mode === 'optin' && optedIn)
